import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import api from "../../lib/api";

export default function LocationTracker() {
    const { user } = useAuth();

    useEffect(() => {
        if (!user) return;
        
        // Track locations for employees and interns
        if (user.role !== "employee" && user.role !== "intern") return;

        let intervalId = null;

        const checkAndTrack = async () => {
            try {
                // Check if user is punched in and hasn't punched out yet
                const res = await api.get("/attendance/today");
                const att = res.data;
                
                if (att && att.punch_in && !att.punch_out) {
                    const now = new Date();
                    // Stop tracking if it is 6 PM or later
                    if (now.getHours() >= 18) {
                        if (intervalId) {
                            clearInterval(intervalId);
                            intervalId = null;
                        }
                        return;
                    }

                    navigator.geolocation.getCurrentPosition(
                        async (position) => {
                            const { latitude, longitude } = position.coords;
                            try {
                                await api.post("/attendance/location", {
                                    latitude,
                                    longitude
                                });
                            } catch (e) {
                                console.error("Error pinging location:", e);
                            }
                        },
                        (err) => {
                            console.error("GPS retrieval error:", err);
                        },
                        { enableHighAccuracy: true }
                    );
                } else {
                    if (intervalId) {
                        clearInterval(intervalId);
                        intervalId = null;
                    }
                }
            } catch (err) {
                console.error("Error loading today status for tracking:", err);
            }
        };

        checkAndTrack();
        intervalId = setInterval(checkAndTrack, 180000); // 3 minutes

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [user]);

    return null;
}
